<template>
    <v-container>
        <tryout-form v-model="formIsValid"></tryout-form>

        <question-importer></question-importer>

        <tryout-question></tryout-question>

        <div class="text-right mt-4">
            <v-btn
                @click="save"
                rounded
                color="primary"
                :disabled="! dataComplete"
                :loading="$store.get('loader/loading', 'saving')"
            >
                Buat tryout
            </v-btn>
        </div>
    </v-container>
</template>

<script>
import TryoutForm from './TryoutForm'
import QuestionImporter from './QuestionImporter'
import TryoutQuestion from './TryoutQuestion'
import { get } from 'vuex-pathify'

export default {
    components: {
        TryoutForm,
        QuestionImporter,
        TryoutQuestion,
    },

    data() {
        return {
            formIsValid: null,
        }
    },

    computed: {
        ...get('createtryout/*'),

        dataComplete() {
            return this.formIsValid
        }
    },

    methods: {
        save() {
            this.$api.post('tryout', {
                period_id: this.$route.params.period_id,
                ...this.$store.get('createtryout/formInput')
            }, { loader: 'saving' })
                .then(response => {
                    if (response.data.created) {
                        this.$store.dispatch('flash/info', 'Tryout dibuat')
                        this.$router.replace({ name: 'period.detail', params: { period_id: this.$route.params.period_id } })
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
        }
    },

    destroyed() {
        this.$store.commit('createtryout/RESET')
    }
}
</script>
